import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}


//客户管理 -- 查询公司和项目 -- 潘
getData.getCompPro = (data)=>{ 
    return http.get(baseUrl+"/one/childprojectlist/",{ params:data })
}
// 项目管理-- 侧边栏项目 -- 潘
getData.getProject = (data)=>{ 
    return http.get(baseUrl+"/one/fontchildprojectlist/",{ params:data })
}
//客户管理 -- 新增项目 -- 潘
getData.addProject = (data)=>{ 
    return http.post(baseUrl+"/one/createproject/",data)
}
//客户管理 -- 删除项目 -- 潘
getData.deleteProject = (data)=>{ 
    return http.post(baseUrl+"/one/deleteproject/",data)
}

//客户管理 -- 回收站列表 -- 范
getData.trashprojects = (data)=>{ 
    return http.get(baseUrl+"/one/trashprojects/",{ params:data })
}
//客户管理 -- 回收站恢复 -- 范
getData.trashprojectput = (pk,data)=>{ 
    return http.put(baseUrl+"/one/trashproject/"+pk+"/",data)
}
//客户管理 -- 回收站彻底删除 -- 范
getData.trashprojectdel = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/trashproject/"+ pk+"/",data)
}
//客户管理 -- 新增设备 -- 潘
getData.addDevice = (data)=>{ 
    return http.post(baseUrl+"/one/applydevice/",data)
}
// 项目管理-- 获取设备信息 -- 潘
getData.getEquipment = (data)=>{ 
    return http.post(baseUrl+"/one/devicelist/",data)
}
// 项目管理-- 获取单个设备信息 -- 潘
getData.viewdevice = (id,comp_id,pro_id,data)=>{ 
    return http.get(baseUrl+"/one/viewdevice/?d_id="+id+"&d_company_id="+comp_id+"&d_project_id="+pro_id,{ params:data })
}
// 项目管理-- 修改设备信息 -- 潘
getData.editEquipment = (data)=>{ 
    return http.post(baseUrl+"/one/editdevice/",data)
}
// 项目管理-- 删除设备信息 -- 潘
getData.deleteEquipment = (data)=>{ 
    return http.post(baseUrl+"/one/deletedevice/",data)
}


// 系统管理-- 查询采集设备列表信息 -- 潘
getData.getCollectDeviceList = (data)=>{ 
    return http.post(baseUrl+"/one/collectdevicelist/",data)
}
// 系统管理-- 添加采集设备信息 -- 潘
getData.addCollectDevice = (data)=>{ 
    return http.post(baseUrl+"/one/applycollectdevice/",data)
}
// 系统管理-- 删除单个采集设备信息 -- 潘
getData.delColDevice = (data)=>{ 
    return http.post(baseUrl+"/one/delcollectdevice/",data)
}
// 系统管理-- 查询单个采集设备信息 -- 潘
getData.getColDevice = (id,d_id,data)=>{ 
    return http.get(baseUrl+"/one/editcollectdevice/?user_id="+id+"&cdevice_id="+d_id,{ params:data })
}
// 系统管理-- 修改采集设备信息 -- 潘
getData.editColDevice = (data)=>{ 
    return http.post(baseUrl+"/one/editcollectdevice/",data)
}
// 客户管理-- 添加采集设备信息 -- 潘
getData.addCusColDevice = (data)=>{ 
    return http.post(baseUrl+"/one/customapplycollectdevice/",data)
}
// 客户管理-- 查询采集设备列表信息 -- 潘
getData.getCusColDeviceList = (data)=>{ 
    return http.post(baseUrl+"/one/customcollectdevicelist/",data)
}
// 客户管理-- 将采集设备与项目解绑 -- 潘
getData.delCusColDevice = (data)=>{ 
    return http.post(baseUrl+"/one/customdeletecollectdevice/",data)
}
// 关联员工-- 查询员工职位及员工信息 -- 潘
getData.getTypeStaff = (data)=>{ 
    return http.get(baseUrl+"/one/typestafflist/",{ params:data })
}
// 关联员工-- 查询公司员工列表---用户控制台 -- 潘
getData.getFontTypeStaff = (data)=>{ 
    return http.get(baseUrl+"/one/fonttypestafflist/",{ params:data })
}
// 关联员工-- 将后台员工与项目绑定 -- 潘
getData.bindingStaff = (data)=>{ 
    return http.post(baseUrl+"/one/bindstaffproject/",data)
}
// 关联员工-- 查询绑定到项目的员工 -- 潘
getData.getStaffList = (data)=>{ 
    return http.post(baseUrl+"/one/stafflist/",data)
}
// 关联员工-- 将员工与项目解绑 -- 潘
getData.unBindStaffList = (data)=>{ 
    return http.post(baseUrl+"/one/unbindstaffproject/",data)
}

// 维保记录-- 添加维保记录获取全部设备信息(不分页) -- 潘
getData.getDevicelistall = (data)=>{ 
    return http.post(baseUrl+"/one/devicelistall/",data)
}
// 维保记录-- 添加维保记录 -- 潘
getData.addMaintenance = (data)=>{ 
    return http.post(baseUrl+"/one/addmaintainrecord/",data)
}
// 维保记录-- 查询维保记录列表 -- 潘
getData.getMaintenanceList = (data)=>{ 
    return http.post(baseUrl+"/one/maintainrecordlist/",data)
}
// 维保记录-- 查询单条维保记录信息 -- 潘
getData.getMaintenance = (data)=>{ 
    return http.post(baseUrl+"/one/viewmaintainrecord/",data)
}
// 维保记录-- 修改维保记录信息 -- 潘
getData.editMaintenance = (data)=>{ 
    return http.post(baseUrl+"/one/editmaintainrecord/",data)
}
// 维保记录-- 删除单条维保记录信息 -- 潘
getData.deleteMaintenance = (data)=>{ 
    return http.post(baseUrl+"/one/deletemaintainrecord/",data)
}

// 组态列表-- 添加组态链接 -- 潘
getData.addDashboard = (data)=>{ 
    return http.post(baseUrl+"/one/createdashboard/",data)
}
// 组态列表-- 查询组态链接列表 -- 潘
getData.getDashboardList = (data)=>{ 
    return http.post(baseUrl+"/one/dashboardlist/",data)
}
// 组态列表-- 查询单个组态链接信息 -- 潘
getData.getDashboard = (data)=>{ 
    return http.post(baseUrl+"/one/viewdashboard/",data)
}
// 组态列表-- 修改单个组态链接信息 -- 潘
getData.editDashboard = (data)=>{ 
    return http.post(baseUrl+"/one/editdashboard/",data)
}
// 组态列表-- 修改单个组态链接信息 -- 潘
getData.deleteDashboard = (data)=>{ 
    return http.post(baseUrl+"/one/deletedashboard/",data)
}

// ---------------------------参数列表部分接口----------------------------------
//参数列表 -- 查询参数列表 -- 潘
getData.getParameter = (data)=>{ 
    return http.post(baseUrl+"/one/viewparameter/",data)
}
//参数列表 -- 查询标签列表 -- 潘
getData.getParamTags = (data)=>{ 
    return http.post(baseUrl+"/one/viewtag/",data)
}
//参数列表 -- 绑定参数和标签 -- 潘
getData.bindTagParam = (data)=>{ 
    return http.post(baseUrl+"/one/bindtagparameter/",data)
}
//参数列表 -- 查看已绑定标签的参数 -- 潘
getData.viewBindParam = (data)=>{ 
    return http.post(baseUrl+"/one/viewbindtagparameter/",data)
}
//参数列表 -- 解绑参数和标签 -- 潘
getData.deleteBindParam = (data)=>{ 
    return http.post(baseUrl+"/one/unbindtagparameter/",data)
}
//--------------------------------图表显示组------------------------------------------
//参数列表 -- 图表显示组-- 绑定图表显示组参数 -- 潘
getData.bindChartGroup = (data)=>{ 
    return http.post(baseUrl+"/one/bindchartgroup/",data)
}
//参数列表 -- 图表显示组-- 查看已绑定参数的图表显示组 -- 潘
getData.viewChartGroup = (data)=>{ 
    return http.post(baseUrl+"/one/viewchartgroup/",data)
}
//参数列表 -- 图表显示组-- 查看单个图表显示组 -- 潘
getData.viewOneChartGroup = (data)=>{ 
    return http.post(baseUrl+"/one/viewonechartgroup/",data)
}
//参数列表 -- 图表显示组-- 解绑已绑定参数的图表显示组 -- 潘
getData.deleteChartGroup = (data)=>{ 
    return http.post(baseUrl+"/one/unbindchartgroup/",data)
}
//参数列表 -- 图表显示组-- 解绑图表显示组下的单个参数 -- 潘
getData.deleteChartGroupOne = (data)=>{ 
    return http.post(baseUrl+"/one/unbindchartgroupone/",data)
}
//----------------------------------设备显示组----------------------------------------
//参数列表 -- 设备显示组-- 绑定设备显示组参数 -- 潘
getData.bindDeviceGroup = (data)=>{ 
    return http.post(baseUrl+"/one/binddevicegroup/",data)
}
//参数列表 -- 设备显示组-- 查看已绑定参数的设备显示组 -- 潘
getData.viewDeviceGroup = (data)=>{ 
    return http.post(baseUrl+"/one/viewdevicegroup/",data)
}
//参数列表 -- 设备显示组-- 删除已绑定参数的设备显示组 -- 潘
getData.deleteDeviceGroup = (data)=>{ 
    return http.post(baseUrl+"/one/unbinddevicegroup/",data)
}
//参数列表 -- 设备显示组-- 删除设备显示组下的单个图表显示组 -- 潘
getData.deleteDeviceGroupOne = (data)=>{ 
    return http.post(baseUrl+"/one/unbinddevicegroupone/",data)
}
//----------------------------------未分组参数----------------------------------------
//参数列表 -- 设备显示组-- 绑定设备显示组参数 -- 潘
getData.viewUnbindtagParame = (data)=>{ 
    return http.post(baseUrl+"/one/viewunbindtagparameter/",data)
}
//----------------------------------报警规则----------------------------------------






export default getData


// WEBPACK FOOTER //
// ./src/common/customer.js